var transform = {
  serializeIn: function serializeIn(settings) {
    var _a;

    return {
      formatValue: typeof ((_a = settings === null || settings === void 0 ? void 0 : settings.tooltipSettings) === null || _a === void 0 ? void 0 : _a.formatValue) === 'string' ? settings.tooltipSettings.formatValue : null,
      valueMode: settings.valueMode
    };
  },
  serializeOut: function serializeOut(_ref) {
    var formatValue = _ref.formatValue,
        valueMode = _ref.valueMode;
    return {
      tooltipSettings: {
        formatValue: formatValue
      },
      valueMode: valueMode
    };
  }
};
export default transform;